import { CardHistoricoConfig } from "./Base/types";
import { demandaCriadaConfig } from "./Cards/DemandaCriada/CardDemandaCriada";
import { demandaEditadaConfig } from "./Cards/DemandaEditada/CardDemandaEditada";
import { orientacaoPreviaCriadaConfig } from "./Cards/OrientacaoPreviaCriada/CardOrientacaoPreviaCriada";
import { orientacaoPreviaEditadaConfig } from "./Cards/OrientacaoPreviaEditada/CardOrientacaoPreviaEditada";
import { orientacaoCompletaCriadaConfig } from "./Cards/OrientacaoCompletaCriada/CardOrientacaoCompletaCriada";
import { orientacaoCompletaEditadaConfig } from "./Cards/OrientacaoCompletaEditada/CardOrientacaoCompletaEditada";
import { cienciaProfissionalConfig } from "./Cards/CienciaProfissional/CardCienciaProfissional";
import { demandaCanceladaConfig } from "./Cards/DemandaCancelada/CardDemandaCancelada";
import { demandaFinalizadaConfig } from "./Cards/DemandaFinalizada/CardDemandaFinalizada";
import { demandaRetornadaExecucaoConfig } from "./Cards/DemandaRetornadaExecucao/CardDemandaRetornadaExecucao";
import { recusaProfissionalConfig } from "./Cards/RecusaProfissional/CardRecusaProfissional";
import { conclusaoProfissionalConfig } from "./Cards/ConclusaoProfissional/CardConclusaoProfissional";
import { profissionalAtribuidoConfig } from "./Cards/ProfissionalAtribuido/CardProfissionalAtribuido";
import { profissionalAlteradoConfig } from "./Cards/ProfissionalAlterado/CardProfissionalAlterado";
import { solicitanteAtribuidoConfig } from "./Cards/SolicitanteAtribuido/CardSolicitanteAtribuido";
import { anexoAdicionadoConfig } from "./Cards/AnexoAdicionado/CardAnexoAdicionado";
import { anexoRemovidoConfig } from "./Cards/AnexoRemovido/CardAnexoRemovido";
import { pendenciaCriadaConfig } from "./Cards/PendenciaCriada/CardPendenciaCriada";
import { pendenciaMovidaConfig } from "./Cards/PendenciaMovida/CardPendenciaMovida";
import { pendenciaAceitaConfig } from "./Cards/PendenciaAceita/CardPendenciaAceita";
import { pendenciaConcluidaConfig } from "./Cards/PendenciaConcluida/CardPendenciaConcluida";
import { comentarioConfig } from "./Cards/Comentario/CardComentario";
import { triagemIniciadaConfig } from "./Cards/TriagemIniciada/CardTriagemIniciada";
import { contratacaoIniciadaConfig } from "./Cards/ContratacaoIniciada/CardContratacaoIniciada";
import { demandaIniciadaConfig } from "./Cards/DemandaIniciada/CardDemandaIniciada";
import { demandaInterrompidaConfig } from "./Cards/DemandaInterrompida/CardDemandaInterrompida";
import { demandaAceitaConfig } from "./Cards/DemandaAceita/CardDemandaAceita";
import { prazoAceiteExcedidoConfig } from "./Cards/PrazoAceiteExcedido/CardPrazoAceiteExcedido";
import { 
    CirclePlus, 
    CircleCheckBig, 
    CircleX, 
    UserPlus, 
    UserX, 
    FileUp,
    MessageSquare,
    ArrowRight,
    CheckCircle,
    XCircle,
    LucideIcon 
} from "lucide-react";

const cardsRegistrados: CardHistoricoConfig[] = [
    triagemIniciadaConfig,
    contratacaoIniciadaConfig,
    demandaIniciadaConfig,
    demandaInterrompidaConfig,
    demandaAceitaConfig,
    profissionalAlteradoConfig,
    demandaCriadaConfig,
    orientacaoPreviaCriadaConfig,
    orientacaoPreviaEditadaConfig,
    orientacaoCompletaCriadaConfig,
    orientacaoCompletaEditadaConfig,
    demandaEditadaConfig,
    cienciaProfissionalConfig,
    demandaCanceladaConfig,
    demandaFinalizadaConfig,
    demandaRetornadaExecucaoConfig,
    recusaProfissionalConfig,
    conclusaoProfissionalConfig,
    profissionalAtribuidoConfig,
    solicitanteAtribuidoConfig,
    anexoAdicionadoConfig,
    anexoRemovidoConfig,
    pendenciaCriadaConfig,
    pendenciaMovidaConfig,
    pendenciaAceitaConfig,
    pendenciaConcluidaConfig,
    comentarioConfig,
    prazoAceiteExcedidoConfig
];

export const detectarTipoCard = (acao: string): CardHistoricoConfig | null => {
    for (const cardConfig of cardsRegistrados) {
        if (cardConfig.detectaTipo(acao)) {
            return cardConfig;
        }
    }
    return null;
};

export const getCardConfig = (tipo: string): CardHistoricoConfig | null => {
    return cardsRegistrados.find(config => config.tipo === tipo) || null;
};

/**
 * Obtém o ícone e cor para uma ação do histórico.
 * Prioriza o ícone do cardConfig se disponível, caso contrário usa o mapeamento padrão.
 */
export const getIconForAction = (acao: string): { Icon: LucideIcon; color: string } => {
    if (!acao) {
        return { Icon: CirclePlus, color: 'var(--c6b7280)' };
    }
    
    // Primeiro, tenta usar o ícone do cardConfig se disponível
    const cardConfig = detectarTipoCard(acao);
    if (cardConfig) {
        return cardConfig.getIcon(acao);
    }
    
    // Fallback para mapeamento padrão
    const acaoLower = acao.toLowerCase().trim();
    
    if (acaoLower.includes('criou proposta') || acaoLower === 'demanda criada') {
        return { Icon: CirclePlus, color: 'var(--c2e86de)' };
    }
    
    if (acaoLower.includes('aceitou proposta') || acaoLower.includes('aceita') || acaoLower.includes('finalizou demanda com aceite')) {
        return { Icon: CircleCheckBig, color: 'var(--c2e86de)' };
    }
    
    if (acaoLower.includes('recusou proposta') || acaoLower.includes('recusada') || acaoLower.includes('finalizou demanda com recusa')) {
        return { Icon: CircleX, color: 'var(--ce5293f)' };
    }
    
    if (acaoLower.includes('profissional') && acaoLower.includes('alterado') && !acaoLower.includes('atribuido')) {
        return { Icon: UserPlus, color: 'var(--cf59e0b)' };
    }
    
    if (acaoLower.includes('profissional') && (acaoLower.includes('atribuído') || acaoLower.includes('atribuido') || acaoLower.includes('atribuiu profissional'))) {
        return { Icon: UserPlus, color: 'var(--c8041c7)' };
    }
    
    if (acaoLower.includes('profissional') && acaoLower.includes('removido')) {
        return { Icon: UserX, color: 'var(--c8041c7)' };
    }
    
    if (acaoLower.includes('solicitante') && (acaoLower.includes('atribuído') || acaoLower.includes('atribuido') || acaoLower.includes('atribuiu escritório solicitante') || acaoLower.includes('alterou escritório solicitante'))) {
        return { Icon: UserPlus, color: 'var(--c8041c7)' };
    }
    
    if (acaoLower.includes('anexo') && acaoLower.includes('adicionado')) {
        return { Icon: FileUp, color: 'var(--c41c49f)' };
    }

    if (acaoLower.includes('anexo') && acaoLower.includes('removeu')) {
        return { Icon: FileUp, color: 'var(--ce5293f)' };
    }
    
    if (acaoLower.includes('pendência criada') || acaoLower.includes('pendencia criada')) {
        return { Icon: MessageSquare, color: 'var(--c2e86de)' };
    }
    
    if (acaoLower.includes('pendência movida') || acaoLower.includes('pendencia movida') || acaoLower.includes('movida para')) {
        return { Icon: ArrowRight, color: 'var(--c8041c7)' };
    }
    
    if (acaoLower.includes('pendência concluída') || acaoLower.includes('pendencia concluida') || acaoLower.includes('respondeu pendência') || acaoLower.includes('respondeu pendencia')) {
        if (acaoLower.includes('recusada') || acaoLower.includes('recusou')) {
            return { Icon: XCircle, color: 'var(--ce5293f)' };
        }
        return { Icon: CheckCircle, color: 'var(--c2e86de)' };
    }
    
    if (acaoLower.includes('conclusão') || acaoLower.includes('concluiu')) {
        return { Icon: CircleCheckBig, color: 'var(--c2e86de)' };
    }
    
    if (acaoLower.includes('cancelada') || acaoLower.includes('cancelou')) {
        return { Icon: CircleX, color: 'var(--c95a5a6)' };
    }
    
    return { Icon: CirclePlus, color: 'var(--c6b7280)' };
};

